import { Button, Paper, Stack, Typography } from '@mui/material'

type ErrorStateProps = {
    message: string
    onAction?: () => void
    actionLabel?: string
    minHeight?: number | string
}

const ErrorState = ({ 
    message, 
    onAction, 
    actionLabel = 'Trở lại',
    minHeight = 300 
}: ErrorStateProps) => {
    return (
        <Paper elevation={0} sx={{ p: 4, borderRadius: 3, boxShadow: '0px 8px 24px rgba(15,15,15,0.06)' }}>
            <Stack alignItems="center" justifyContent="center" minHeight={minHeight} spacing={2}>
                <Typography color="error.main" fontWeight={600}>
                    {message}
                </Typography>
                {onAction && (
                    <Button
                        variant="contained"
                        onClick={onAction}
                        sx={{ backgroundColor: '#dc3545', textTransform: 'capitalize', px: 5 }}>
                        {actionLabel}
                    </Button>
                )}
            </Stack>
        </Paper>
    )
}

export default ErrorState

